import { Component } from '@angular/core';
import {
    AutoFocusDirective,
    ErrorsUtil,
    InputComponent,
    MessageBoxComponent,
    OnEnterDirective,
    WaitButtonComponent
} from '@sircon/sircon-ui-framework';
import { Router, RouterLink } from '@angular/router';
import { AccountHttpService } from 'src/providers/account-http.service';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.less'],
    imports: [RouterLink, OnEnterDirective, NgIf, MessageBoxComponent, InputComponent, AutoFocusDirective, FormsModule,
        WaitButtonComponent]
})
export class ForgotPasswordComponent {
    errors: any = ErrorsUtil.create();
    submitting;
    form: any = {};
    passwordResetSent;

    constructor(
        private accountHttpService: AccountHttpService,
        private router: Router
    ) {
    }

    submit() {
        this.submitting = true;
        ErrorsUtil.clear(this.errors);

        this.accountHttpService.sendPasswordResetEmail(this.form).toPromise().then(() => {
            this.router.navigate(['/login'], { queryParams: {
                successMessage: 'An email sent to the address you provided contains instructions for resetting your password.'
            }});
        }).catch((response) => {
            if (response.status === 404) {
                this.passwordResetSent = true;
                this.router.navigate(['/login'], { queryParams: {
                    successMessage: 'An email sent to the address you provided contains instructions for resetting your password.'
                }});
            } else {
                this.errors = ErrorsUtil.mapResponse(response);
            }
        }).finally(() => {
            this.submitting = false;
        });
    }
}
